
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetQuery from "./helper/useGetQuery"
import useUpdateMutationById from "./helper/useUpdateMutationById"

  const API = {
    GET: "/api/admin/contact",
    ADD: "/api/admin/contact",
    UPDATE: "/api/admin/contact",
    DELETE: "/api/admin/contact",
  };

  const KEY = "CONTACT";
  export const useGetContact = (params?:any) => useGetQuery(KEY, API.GET, params);
  export const useAddContact = () => useAddMutation(KEY, API.ADD);
  export const useUpdateContact = () => useUpdateMutationById(KEY, API.UPDATE);
  export const useDeleteContact = () =>useDeleteMutation(KEY, API.DELETE);
